import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid2'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import Typography from '@mui/material/Typography'
import { isEqual } from 'lodash'
import * as React from 'react'
import { useCallback, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { WrapperCenter } from '../../../components/WrapperCenter/WrapperCenter'
import { useAssistantAdministrationStore } from '../../../store/storeAssistantAdministration'

import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import IconButton from '@mui/material/IconButton'
import Skeleton from '@mui/material/Skeleton'
import { ProjectItem } from '../../../components/ProjectItem/ProjectItem'
import { RecordImage } from '../../../components/RecordImage/RecordImage'

import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import { useMediaQuery } from '@mui/material'
import moment from 'moment/moment'
import { DateInfoItem } from '../../../components/DateInfoItem/DateInfoItem'
import { BlockWrapper } from '../../../components/Wrapper/BlockWrapper'
import { APP_TOP_INDENT, APP_TOP_INDENT_MOBILE } from '../../../constants/app.indents'
import { RECORDS_ROUTE } from '../../../constants/routing.constants'
import { useWrapperStore } from '../../../store/storeWrapper'
import { theme } from '../../../theme'
import { SidebarType } from '../../../types/sidebars'
import { RecordItemMenu } from '../RecordsPage/components/RecordItemMenu'
import { Memo } from './components/Memo'
import { Stenograhy } from './components/Stenography'

const tabMode = {
    0: 'detail',
    1: 'steno',
    2: 'memo',
}

export const RecordDetailPage = () => {
    const navigate = useNavigate()
    const params = useParams()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const [value, setValue] = React.useState(0)
    const [isRequest, setIsRequest] = React.useState(false)
    const [isEdit, setIsEdit] = React.useState(false)
    const [recordName, setRecordName] = React.useState({
        new: '',
        old: '',
    })

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue)
        setTabRecordDetail(tabMode[+newValue])
    }

    const { openSidebarType, setOpenSidebarType } = useWrapperStore((state) => state)
    const { updateRecord, setTabRecordDetail, fetchRecordDetail, record, errorFetchRecordDetail } =
        useAssistantAdministrationStore((state) => state)

    useEffect(() => {
        fetchRecordDetail({
            recordId: params?.recordId,
        })
    }, [params?.recordId, fetchRecordDetail])

    useEffect(() => {
        if (
            record &&
            !(
                (record?.last_stage?.stage_type === 'MEMO' &&
                    record?.last_stage?.status === 'COMPLETED') ||
                record?.last_stage?.status === 'ERROR'
            )
        ) {
            setIsRequest(true)
        } else {
            setIsRequest(false)
        }
    }, [record])

    useEffect(() => {
        let interval: NodeJS.Timeout
        if (isRequest) {
            interval = setInterval(() => {
                fetchRecordDetail({
                    recordId: params?.recordId,
                })
            }, 60000)
        }

        return () => clearInterval(interval)
    }, [isRequest, params?.recordId, fetchRecordDetail])

    useEffect(() => {
        if (record) {
            const setTitle = record.title?.length > 0 ? record.title : 'Название записи'
            setRecordName({ new: setTitle, old: setTitle })
        }
    }, [record])

    const handleUserKeyPress = useCallback((e) => {
        if (e.key === 'Enter') {
            e.preventDefault()
            e.stopPropagation()
            handelClickEdit()
        }
    }, [])
    useEffect(() => {
        if (isEdit) {
            window.addEventListener('keyup', handleUserKeyPress)
        } else {
            window.removeEventListener('keyup', handleUserKeyPress)
        }
    }, [handleUserKeyPress, isEdit])

    const handelClickEdit = async () => {
        setIsEdit(false)
        if (!isEqual(recordName.old, recordName.new)) {
            await updateRecord({ recordId: record.id }, { title: recordName.new })
        }

        setIsEdit(false)
    }

    const handleClickOpenRecordSetting = (value) => {
        setOpenSidebarType(value ? SidebarType.RECORD_SETTINGS : null)
    }

    const handleBack = () => {
        navigate(`${RECORDS_ROUTE}/?is_archived=${record?.is_archived ?? false}`)
    }

    return (
        <BlockWrapper>
            <Grid
                sx={{
                    height: `calc(100dvh - ${isMobile ? APP_TOP_INDENT_MOBILE : APP_TOP_INDENT}px)`,
                    pt: 2,
                    px: 1,
                    overflowY: 'auto',
                }}>
                {errorFetchRecordDetail && (
                    <WrapperCenter>
                        <Typography color="error" variant="h4">
                            Такой записи не существует! Выберите другую запись из списка
                        </Typography>
                    </WrapperCenter>
                )}

                <Grid
                    container
                    sx={{
                        height: `100%`,
                        position: 'relative',
                        left: 0,
                        alignItems: 'flex-end',
                        alignContent: 'flex-start',
                        textAlign: 'left',
                    }}
                    spacing={4}>
                    <Grid size={12} sx={{ height: '56px' }}>
                        <Stack
                            direction="row"
                            spacing={1}
                            sx={{
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                height: '56px',
                            }}>
                            <Stack direction="row" sx={{ alignItems: 'center', width: '75%' }}>
                                <IconButton
                                    sx={{
                                        '&:hover': { borderColor: '#F4F4F6' },
                                        background: ' #fff',
                                    }}
                                    variant="text"
                                    color="primary"
                                    onClick={handleBack}>
                                    <ArrowBackIcon />
                                </IconButton>
                                <Grid
                                    sx={{
                                        px: 1,
                                        alignItems: 'flex-start',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        width: '100%',
                                    }}>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: '#121317',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                        }}>
                                        {record ? record?.title : <Skeleton width={210} />}
                                    </Typography>
                                    {record ? (
                                        <Stack
                                            sx={{
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                width: '100%',
                                            }}>
                                            <ProjectItem projectId={record?.workplace_id} />
                                        </Stack>
                                    ) : (
                                        <Skeleton width={210} />
                                    )}
                                </Grid>
                            </Stack>
                            <Stack direction="row">
                                <IconButton
                                    sx={{
                                        '&:hover': { borderColor: '#F4F4F6' },
                                        background: ' #fff',
                                        zIndex: 1000,
                                    }}
                                    variant="text"
                                    color="primary"
                                    onClick={() =>
                                        handleClickOpenRecordSetting(
                                            openSidebarType === SidebarType.RECORD_SETTINGS
                                                ? null
                                                : SidebarType.RECORD_SETTINGS,
                                        )
                                    }>
                                    <SettingsOutlinedIcon />
                                </IconButton>
                                <RecordItemMenu record={record} />
                            </Stack>
                        </Stack>
                        <Divider />
                    </Grid>
                    {record && (
                        <Grid sx={{ padding: isMobile ? 0 : '0 16px 16px 24px ' }} size={12}>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                sx={{ borderBottom: 'none', padding: 0 }}>
                                <Tab id="0" label="Детали записи" />
                                <Tab label="Стенография" id="1" />
                            </Tabs>
                            {record && value === 0 && (
                                <>
                                    <Grid container spacing={2} mt={1}>
                                        <Grid
                                            size={6}
                                            sx={{
                                                cursor: 'pointer',
                                                width: '310px',
                                                marginBottom: '16px',
                                            }}>
                                            <Paper
                                                onClick={() =>
                                                    window.open(
                                                        record.source_info.source_url,
                                                        '_blank',
                                                    )
                                                }
                                                sx={{
                                                    position: 'relative',
                                                    justifyContent: 'center',
                                                    flexDirection: 'column',
                                                }}>
                                                <RecordImage record={record} />
                                            </Paper>
                                        </Grid>
                                        <Grid
                                            size={6}
                                            sx={{
                                                cursor: 'pointer',
                                                width: '310px',
                                                marginBottom: '16px',
                                            }}>
                                            <Typography
                                                variant="h6"
                                                sx={{
                                                    color: '#121317',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    mb: 1,
                                                }}>
                                                {record ? record?.title : <Skeleton width={210} />}
                                            </Typography>
                                            <Typography
                                                variant="caption1"
                                                sx={{
                                                    mb: 0,
                                                    color: '#5A5F72',
                                                }}>
                                                <DateInfoItem date={record.created_at} />
                                            </Typography>
                                            <Typography
                                                variant="caption2"
                                                sx={{
                                                    color: '#5A5F72',
                                                }}>
                                                {moment
                                                    .utc(record.source_info.duration_sec * 1000)
                                                    .format('HH:mm:ss')}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Memo recordId={params?.recordId} />
                                </>
                            )}
                            {record && value === 1 && <Stenograhy recordId={params?.recordId} />}
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </BlockWrapper>
    )
}
